/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "universal-cookie";
import { getAccountInformation } from "../containers/account/actions";
import Loader from "./loader";
import { getAnnouncement } from "../containers/admin/addAnnouncement/redux/action";
import { getAnnouncementLoader } from "../containers/admin/addAnnouncement/redux/selectors";
import { SET_ANNOUNCEMENT_LOADER } from "../containers/admin/addAnnouncement/redux/constants";
import { INITIAL_LOADER } from "../containers/account/constants";

const cookie = new Cookies();

export default function LoadUser({ children }: any) {
  const userToken = cookie.get("user_token");
  const dispatch = useDispatch();
  const announcementLoader = useSelector(getAnnouncementLoader);
  const userLoader = useSelector((state: any) => state?.my_account?.initialLoader);
  const [mainLoader, setMainLoader] = useState(true);

  useEffect(() => {
    setMainLoader(false);
    dispatch({ type: SET_ANNOUNCEMENT_LOADER, payload: true });
    dispatch(getAnnouncement());
    if (userToken) {
      dispatch({ type: INITIAL_LOADER, payload: true });
      dispatch(getAccountInformation());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (mainLoader || announcementLoader || userLoader) {
    return <Loader />;
  }

  return children;
}
